import { render, staticRenderFns } from "./ContractsManagements.vue?vue&type=template&id=20c7585c"
import script from "./ContractsManagements.vue?vue&type=script&lang=js"
export * from "./ContractsManagements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports